<div class="ota-detail-modal">
  <div class="modal-header">
    <h2 class="modal-title">Signed Metadata Records</h2>
    <button class="close-btn" (click)="close('close')">&#10005;</button>
  </div>
  <div class="header-divider"></div>

  <div class="modal-body">
    <div class="list-wrapper">
      <table class="records-table">
        <thead>
          <tr>
            <th>Model</th>
            <th>Description</th>
            <th>WF File Name</th>
            <th>WF File Size</th>
            <th>MB File Name</th>
            <th>MB File Size</th>
            <th>Signed At</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of data.details"
            (click)="selectRecord(item)"
            [class.selected-row]="isSelected(item)">
            <td>{{ item.model || '-' }}</td>
            <td>{{ item.description || '-' }}</td>
            <td>{{ item.sign_metadata.wifi?.file_name || '-' }}</td>
            <td>{{ formatFileSize(item.sign_metadata.wifi?.file_size) }}</td>
            <td>{{ item.sign_metadata.mb?.file_name || '-' }}</td>
            <td>{{ formatFileSize(item.sign_metadata.mb?.file_size) }}</td>
            <td>{{ formatSignedAt(item.signed_at) }}</td>
          </tr>
          <tr *ngIf="!data.details.length">
            <td colspan="7" class="empty-row">No records found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button class="action-btn" [disabled]="!selectedRecord" (click)="acceptSelection()">Accept Selection</button>
  </div>
</div>
